import React, { useCallback } from "react";
import { Button, Icon } from "antd";
import styles from "./index.module.scss";

interface StudyBtnProps {
    onClick: () => void;
}

export default function StudyBtn({ onClick }: StudyBtnProps) {
    const handleClick = useCallback(
        (e: React.MouseEvent) => {
            e.stopPropagation();
            onClick();
        },
        [onClick]
    );

    return (
        <Button
            type="primary"
            className={styles.root}
            ghost
            onClick={handleClick}>
            <Icon type="play-circle" /> 继续学习
        </Button>
    );
}
